/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * Enum containing hardware acceleration types.
 * @export
 * @enum {string}
 */
const HardwareAccelerationType = {
    None: 'none',
    Amf: 'amf',
    Qsv: 'qsv',
    Nvenc: 'nvenc',
    V4l2m2m: 'v4l2m2m',
    Vaapi: 'vaapi',
    Videotoolbox: 'videotoolbox',
    Rkmpp: 'rkmpp'
};

export { HardwareAccelerationType };
